// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"626":"8cc4dd9a","798":"8cc4dd9a"}[chunkId] + ".chunk.css";
};